import MiniStatisticsWidget from './components/MiniStatisticsWidget';
import StatisticsPage from './components/StatisticsPage';
import StatisticsWidget from './components/StatisticsWidget';
import StatisticsWidgetDateSelectionModal from './components/StatisticsWidgetDateSelectionModal';

export default {
  'statistics/components/MiniStatisticsWidget': MiniStatisticsWidget,
  'statistics/components/StatisticsPage': StatisticsPage,
  'statistics/components/StatisticsWidget': StatisticsWidget,
  'statistics/components/StatisticsWidgetDateSelectionModal': StatisticsWidgetDateSelectionModal,
};
